<template>
  <div class="masterdata-right">
    <div class="masterdata-table">
      <table class="table-db table-db-hover">
        <thead>
          <tr>
            <th v-if="isEdit" class="editRow"></th>
            <th @click="sort('id')">
              id
              <i
                :class="
                  currentSort === 'id'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('provinsi')">
              Provinsi
              <i
                :class="
                  currentSort === 'provinsi'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('desc')">
              Kota/Kabupaten
              <i
                :class="
                  currentSort === 'desc'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('updatedAt')">
              Last Modified Date
              <i
                :class="
                  currentSort === 'updatedAt'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('update_by')">
              Last Modified By
              <i
                :class="
                  currentSort === 'update_by'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('active')">
              active
              <i
                :class="
                  currentSort === 'active'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
            <th @click="sort('note')">
              catatan
              <i
                :class="
                  currentSort === 'note'
                    ? currentSortDir === 'desc'
                      ? 'fas fa-long-arrow-alt-down'
                      : 'fas fa-long-arrow-alt-up'
                    : 'fas fa-arrows-alt-v'
                "
              ></i>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(list, index) in sortedData" :key="index">
            <td v-if="isEdit" class="editRow" @click="editRow(list)">
              <span class="fa fa-edit pointer ml20"></span>
            </td>
            <td>{{ index + 1 }}</td>
            <td>{{ $get(list, 'province.desc') }}</td>
            <td>{{ list.desc }}</td>
            <td>{{ formatDate(list.updatedAt) }}</td>
            <td>{{ $get(list, 'user.name', '-') }}</td>
            <td :style="list.active ? 'color:green' : 'color:red'">
              {{ list.active ? 'active' : 'inactive' }}
            </td>
            <td>{{ list.note }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <KBLI
      v-if="showModalEdit"
      :editData="editData"
      @closeModal="closeModal"
      class="notAll"
    />
  </div>
</template>

<script>
export default {
  components: {
    KBLI: () => import('@/views/MasterData/Edit/LegalDoc/Kota.vue'),
  },

  props: {
    isEdit: Boolean,
  },
  data() {
    return {
      currentSort: '',
      currentSortDir: '',
      arrow: false,
      showModalEdit: false,
      editData: {
        id: 0,
        desc: '',
        provinsi: '',
        updatedAt: '',
        update_by: '',
        active: '',
        note: '',
      },
      data: [
        {
          id: 1,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Barat Daya',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 1',
        },
        {
          id: 2,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Besar',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 2',
        },
        {
          id: 3,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Jaya',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 3',
        },
        {
          id: 4,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Selatan',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 4',
        },
        {
          id: 5,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Singkil',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 5',
        },
        {
          id: 6,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Tamiang',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 6',
        },
        {
          id: 7,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Tengah',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 7',
        },
        {
          id: 8,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Tenggara',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 8',
        },
        {
          id: 9,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Timur',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 9',
        },
        {
          id: 10,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Utara',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 10',
        },
        {
          id: 11,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Bener Meriah',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 11',
        },
        {
          id: 12,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Bireuen',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 12',
        },
        {
          id: 13,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Gayo Lues',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 13',
        },
        {
          id: 14,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Nagan Raya',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 14',
        },
        {
          id: 15,
          provinsi: 'Aceh (NAD)',
          desc: 'Kabupaten Aceh Barat',
          updatedAt: '-',
          update_by: 'Sistem',
          active: 'Active',
          note: 'Test 15',
        },
      ],
    }
  },

  methods: {
    sort(s) {
      if (s === this.currentSort) {
        this.currentSortDir = this.currentSortDir === 'asc' ? 'desc' : 'asc'
      }
      this.currentSort = s
    },
    editRow(data) {
      this.editData = {
        id: data.id,
        desc: data.desc,
        provinsi: data.provinsi,
        updatedAt: data.updatedAt,
        update_by: data.update_by,
        active: data.active,
        note: data.note,
      }
      this.showModalEdit = true
    },
    closeModal() {
      this.showModalEdit = false
    },
  },

  computed: {
    kotaData() {
      const result = this.$store.state.mdDatabaseStore.kotaData
      return result
    },
    sortedData() {
      return this.kotaData.sort((a, b) => {
        let modifier = 1
        if (this.currentSortDir === 'desc') modifier = -1
        if (a[this.currentSort] < b[this.currentSort]) return -1 * modifier
        if (a[this.currentSort] > b[this.currentSort]) return 1 * modifier
        return 0
      })
    },
  },
}
</script>
